import * as React from "react";

interface StageOptions {
  stageScale: number;
  stageX: number;
  stageY: number;
}

// Obliczanie długości sceny etc etc
export default function(
  seatSelectorElementRef: any,
  audienceHeight: number,
  audienceWidth: number,
) {
  const [sizer, setSizer] = React.useState<{
    refWidth: number;
    refHeight: number;
    done: boolean;
  }>({
    refWidth: 960,
    refHeight: 720,
    done: false,
  });

  React.useEffect(() => {
    if (seatSelectorElementRef.current && !sizer.done) {
      setSizer({
        done: true,
        refWidth: seatSelectorElementRef.current.getBoundingClientRect().width,
        refHeight: seatSelectorElementRef.current.getBoundingClientRect()
          .height,
      });
    }
  }, []);

  const { refHeight, refWidth } = sizer;

  const marginTopBottom = refWidth < 500 ? 1 : refWidth / 10;
  const marginLeftRight = refWidth < 500 ? 1 : refWidth / 10;

  const aspectRatio = audienceWidth / audienceHeight;

  let canvasWidth = Math.floor(refWidth / audienceWidth) * audienceWidth;

  let canvasHeight = canvasWidth * aspectRatio;
  let scale = 1;

  while (canvasHeight > refHeight) {
    // Should be constant
    canvasHeight = canvasHeight * scale - 0.001;
    canvasWidth = canvasWidth * scale - 0.001;

    scale = scale - 0.001;
  }

  const stageRef: any = React.useRef();
  const [stageState, setStageState] = React.useState<StageOptions>({
    stageScale: 0.8,
    stageX: 0,
    stageY: 0,
  });

  const handleWheelZoom = (e: any) => {
    e.evt.preventDefault();

    const scaleBy = 1.02;
    const stage = e.target.getStage();
    const oldScale = stage.scaleX();
    const mousePointTo = {
      x: stage.getPointerPosition().x / oldScale - stage.x() / oldScale,
      y: stage.getPointerPosition().y / oldScale - stage.y() / oldScale,
    };

    const newScale = e.evt.deltaY > 0 ? oldScale * scaleBy : oldScale / scaleBy;

    setStageState({
      stageScale: newScale,
      stageX:
        -(mousePointTo.x - stage.getPointerPosition().x / newScale) * newScale,
      stageY:
        -(mousePointTo.y - stage.getPointerPosition().y / newScale) * newScale,
    });
  };

  const handleButtonZoom = (deltaY: number) => () => {
    if (stageRef.current) {
      const scaleBy = 1.06;
      const stage = stageRef.current.getStage();

      const oldScale = stage.scaleX();

      const newScale = deltaY > 0 ? oldScale * scaleBy : oldScale / scaleBy;

      const mousePointTo = {
        x: canvasWidth / 2 / oldScale - stage.x() / oldScale,
        y: canvasHeight / 2 / oldScale - stage.y() / oldScale,
      };

      setStageState({
        ...stageState,
        stageScale: newScale,
        stageX: -(mousePointTo.x - canvasWidth / 2 / newScale) * newScale,
        stageY: -(mousePointTo.y - canvasHeight / 2 / newScale) * newScale,
      });
    }
  };

  const resetZoom = () => {
    setStageState({
      stageScale: 0.8,
      stageX: 0,
      stageY: 0,
    });
  };

  return {
    ...stageState,
    stageRef,
    handleButtonZoom,
    handleWheelZoom,
    canvasWidth,
    canvasHeight,
    marginTopBottom,
    marginLeftRight,
    resetZoom,
  };
}
